import { Modal } from 'components/ui/Modal/Modal';
import type { OtpContext } from 'services/payex/otp/types';
import { OtpChannel } from 'services/payex/otp/types';
import { OtpVerificationForm } from './OtpVerificationForm';

type OtpVerificationModalProps = {
  isOpen: boolean;
  email: string;
  senderName: string;
  recipientName?: string;
  context: OtpContext;
  onVerified: () => void;
  onClose: () => void;
};

const OtpVerificationModal = ({
  isOpen,
  email,
  senderName,
  recipientName,
  context,
  onVerified,
  onClose,
}: OtpVerificationModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} allowClosing size="medium">
      <div data-testid="otp-modal">
        <OtpVerificationForm
          isActive={isOpen}
          email={email}
          senderName={senderName}
          recipientName={recipientName}
          context={context}
          channel={OtpChannel.Email}
          onVerified={onVerified}
        />
      </div>
    </Modal>
  );
};

export { OtpVerificationModal };
export type { OtpVerificationModalProps };
